<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-10 offset-sm-1 d-flex flex-column justify-content-center align-items-center">
          <div class="text-center" style="padding: 12px;">
            <img class="img-bordered-sm" :src="info.img_url" alt="user image" style="width:60%; border-radius:20px;">
          </div>
          <div class="text-center">
            <h6>{{ info.display_name }}</h6>
          </div>
          <div class="row w-100 mt-4">
            <div class="col-12">
              <div class="card card-penilaian">
                <div class="card-body text-center">
                  <div class="d-flex justify-content-center align-items-center mb-4">
                    <h4 class="text-bold mb-0">Hasil Tes Kecermatan Penjumlahan Simbol</h4>
                  </div>

                  <!-- ===================== 6 METRIK UTAMA ===================== -->
                  <div v-if="hasil" class="row mb-4">
                    <!-- 1. Total Soal -->
                    <div class="col-sm-3 col-6 mb-2">
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body py-3 px-2 d-flex align-items-center justify-content-center">
                          <div class="d-flex flex-column align-items-center">
                            <i class="fas fa-list-ol fa-lg mb-1" style="color: #39A2DB;"></i>
                            <small class="text-muted text-uppercase font-weight-bold" style="font-size: 10px;">Total Soal</small>
                            <h3 class="mb-0 mt-1" style="color: #39A2DB; font-weight: 800;">{{ hasil.total_soal }}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 2. Benar -->
                    <div class="col-sm-3 col-6 mb-2">
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body py-3 px-2 d-flex align-items-center justify-content-center">
                          <div class="d-flex flex-column align-items-center">
                            <i class="fas fa-check-circle fa-lg mb-1" style="color: #28a745;"></i>
                            <small class="text-muted text-uppercase font-weight-bold" style="font-size: 10px;">Benar</small>
                            <h3 class="mb-0 mt-1" style="color: #28a745; font-weight: 800;">{{ hasil.total_benar }}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 3. Salah -->
                    <div class="col-sm-3 col-6 mb-2">
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body py-3 px-2 d-flex align-items-center justify-content-center">
                          <div class="d-flex flex-column align-items-center">
                            <i class="fas fa-times-circle fa-lg mb-1" style="color: #dc3545;"></i>
                            <small class="text-muted text-uppercase font-weight-bold" style="font-size: 10px;">Salah</small>
                            <h3 class="mb-0 mt-1" style="color: #dc3545; font-weight: 800;">{{ hasil.total_salah }}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 4. Skor -->
                    <div class="col-sm-3 col-6 mb-2">
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body py-3 px-2 d-flex align-items-center justify-content-center">
                          <div class="d-flex flex-column align-items-center">
                            <i class="fas fa-star fa-lg mb-1" style="color: #FFA000;"></i>
                            <small class="text-muted text-uppercase font-weight-bold" style="font-size: 10px;">Skor</small>
                            <h3 class="mb-0 mt-1" style="color: #FFA000; font-weight: 800;">{{ hasil.skor }}<small style="font-size: 14px;">%</small></h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ===================== GRAFIK PERFORMA ===================== -->
                  <div class="card mt-4" style="border: 2px solid #6190E8;">
                    <div class="card-header" style="background: linear-gradient(90deg, #6190E8, #A7BFE8); color: white; font-weight: 700; font-size: 18px;">
                      <i class="fas fa-chart-line"></i> Grafik Performa
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <!-- Grafik Performa per Kolom (model Tes Koran) -->
                        <div class="col-md-12 mb-4">
                          <div class="card h-100">
                            <div class="card-header font-weight-bold">Kurva Kerja per Kolom</div>
                            <div class="card-body text-center">
                              <canvas ref="chartPerforma" height="250"></canvas>
                              <p class="text-muted mt-2 small">Garis biru = jumlah benar, garis merah = jumlah salah — bentuk kurva menunjukkan stabilitas kerja</p>
                            </div>
                          </div>
                        </div>
                        <!-- Kecepatan Menjawab -->
                        <div class="col-md-4 mb-4">
                          <div class="card h-100">
                            <div class="card-header font-weight-bold">Kecepatan Menjawab</div>
                            <div class="card-body">
                              <div class="row text-center">
                                <div class="col-6">
                                  <h3 style="color: #39A2DB;">{{ analysis.kecepatan.soal_per_menit }}</h3>
                                  <p class="text-muted small">Soal / Menit</p>
                                </div>
                                <div class="col-6">
                                  <h3 style="color: #FFA000;">{{ analysis.kecepatan.detik_per_soal }}</h3>
                                  <p class="text-muted small">Detik / Soal</p>
                                </div>
                              </div>
                              <div class="mt-2">
                                <div class="d-flex justify-content-between text-muted small">
                                  <span>Terjawab: {{ analysis.kecepatan.terjawab }}/{{ hasil.total_soal }}</span>
                                  <span>Durasi: {{ analysis.kecepatan.durasi_menit }} menit</span>
                                </div>
                                <div class="progress mt-1" style="height: 8px;">
                                  <div class="progress-bar bg-info" :style="'width:'+ (analysis.kecepatan.terjawab / hasil.total_soal * 100) +'%'"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Distribusi Jawaban -->
                        <div class="col-md-4 mb-4">
                          <div class="card h-100">
                            <div class="card-header font-weight-bold">Distribusi Jawaban</div>
                            <div class="card-body">
                              <canvas ref="chartDistribusi" height="180"></canvas>
                            </div>
                          </div>
                        </div>
                        <!-- Ringkasan per Kolom -->
                        <div class="col-md-4 mb-4">
                          <div class="card h-100">
                            <div class="card-header font-weight-bold">Ringkasan per Kolom</div>
                            <div class="card-body text-left" style="padding: 10px;">
                              <table class="table table-sm table-borderless mb-0">
                                <thead>
                                  <tr>
                                    <th>Kolom</th>
                                    <th class="text-center">Total</th>
                                    <th class="text-center text-success">B</th>
                                    <th class="text-center text-danger">S</th>
                                    <th class="text-center text-muted">-</th>
                                    <th class="text-center">Akurasi</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="col in perColumn" :key="col.kolom">
                                    <td><strong>{{ col.kolom }}</strong></td>
                                    <td class="text-center">{{ col.total }}</td>
                                    <td class="text-center text-success">{{ col.benar }}</td>
                                    <td class="text-center text-danger">{{ col.salah }}</td>
                                    <td class="text-center text-muted">{{ col.tidak_terjawab }}</td>
                                    <td class="text-center">
                                      <span class="badge" :class="akurasiBadge(col.akurasi)">{{ col.akurasi }}%</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ===================== ANALISIS PSIKOTES ===================== -->
                  <div class="card mt-4" style="border: 2px solid #E8A061;">
                    <div class="card-header" style="background: linear-gradient(90deg, #E8A061, #F0C99A); color: white; font-weight: 700; font-size: 18px;">
                      <i class="fas fa-brain"></i> Analisis Psikotes
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <!-- Radar Chart -->
                        <div class="col-md-5 mb-4">
                          <canvas ref="chartRadar" height="300"></canvas>
                          <div class="text-center mt-3">
                            <h5 :style="'color: '+ profilWarna">{{ profilPsikotes.label }}</h5>
                            <p class="text-muted small">Rata-rata: {{ profilPsikotes.rata_rata }}</p>
                          </div>
                        </div>
                        <!-- Detail Skor -->
                        <div class="col-md-7 mb-4">
                          <div class="table-responsive">
                            <table class="table table-borderless">
                              <tbody>
                                <tr v-for="(item, key) in psikometrik" :key="key">
                                  <td class="text-left font-weight-bold" style="width: 140px;">{{ labelPsiko(key) }}</td>
                                  <td style="width: 100px;">
                                    <div class="d-flex align-items-center">
                                      <span :style="'color: '+ warnaSkor(item.skor) + '; font-weight: 700; font-size: 16px;'">{{ item.skor }}</span>
                                      <span class="ml-2 badge" :class="badgeClass(item.label)">{{ item.label }}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="progress" style="height: 8px;">
                                      <div class="progress-bar" :style="'width:'+ item.skor +'%; background-color: '+ warnaSkor(item.skor) +';'" role="progressbar"></div>
                                    </div>
                                  </td>
                                  <td class="text-left text-muted small" style="font-size: 11px;">{{ item.deskripsi }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Referensi Simbol -->
                  <div class="card mt-4" style="border: 2px solid #6190E8;">
                    <div class="card-header" style="background: linear-gradient(90deg, #6190E8, #A7BFE8); color: white; font-weight: 700;">
                      Referensi Simbol
                    </div>
                    <div class="card-body p-1">
                      <div class="d-flex justify-content-around flex-wrap">
                        <div v-for="item in ref" :key="item.id" class="text-center mx-1 my-1">
                          <span style="font-size: 28px;" v-html="item.symbol"></span>
                          <br>
                          <span style="font-weight: 700;">{{ item.angka }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Detail Jawaban -->
                  <div class="card mt-4">
                    <div class="card-header" style="background: linear-gradient(90deg, #6190E8, #A7BFE8); color: white; font-weight: 700;">
                      Detail Jawaban
                    </div>
                    <div class="card-body">
                      <!-- If multiple columns with col_index, show grouped by column -->
                      <template v-if="detailPerKolom.length > 1">
                        <div v-for="(colData, colIdx) in detailPerKolom" :key="colIdx" class="mb-4">
                          <h5 class="badge badge-info" style="font-size: 16px; padding: 8px 16px; margin-bottom: 10px;">
                            Kolom {{ colData.kolom }} ({{ colData.terjawab }}/{{ colData.items.length }} terjawab)
                          </h5>
                          <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                            <table class="table table-bordered table-sm">
                              <thead>
                                <tr>
                                  <th>No</th>
                                  <th>Soal</th>
                                  <th>Jawaban Kamu</th>
                                  <th>Kunci</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in colData.items" :key="item.nomor" :class="rowClass(item)">
                                  <td>{{ item.nomor }}</td>
                                  <td style="font-size: 20px; letter-spacing: 6px;">
                                    <template v-for="(sym, si) in item.symbols">
                                      <span :key="si" v-html="sym"></span>
                                      <span :key="'plus-'+si" v-if="si < item.symbols.length - 1" style="font-size: 14px; color: #888; vertical-align: middle;"> + </span>
                                    </template>
                                  </td>
                                  <td style="font-weight: 700;">{{ item.jawaban !== null && item.jawaban !== '' ? item.jawaban : '-' }}</td>
                                  <td style="font-weight: 700; color: #28a745;">{{ item.correct_answer }}</td>
                                  <td>
                                    <span v-if="item.is_answered == 1" :class="item.is_correct == 1 ? 'text-success' : 'text-danger'">
                                      <i :class="item.is_correct == 1 ? 'fas fa-check' : 'fas fa-times'"></i>
                                      {{ item.is_correct == 1 ? 'Benar' : 'Salah' }}
                                    </span>
                                    <span v-else class="text-warning">
                                      <i class="fas fa-minus"></i> Tidak dijawab
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </template>
                      <!-- If single column, show flat list by sequence -->
                      <template v-else>
                        <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                          <table class="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>No</th>
                                <th>Soal</th>
                                <th>Jawaban Kamu</th>
                                <th>Kunci</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in detail" :key="item.nomor" :class="rowClass(item)">
                                <td>{{ item.nomor }}</td>
                                <td style="font-size: 20px; letter-spacing: 6px;">
                                  <template v-for="(sym, si) in item.symbols">
                                    <span :key="si" v-html="sym"></span>
                                    <span :key="'plus-'+si" v-if="si < item.symbols.length - 1" style="font-size: 14px; color: #888; vertical-align: middle;"> + </span>
                                  </template>
                                </td>
                                <td style="font-weight: 700;">{{ item.jawaban !== null && item.jawaban !== '' ? item.jawaban : '-' }}</td>
                                <td style="font-weight: 700; color: #28a745;">{{ item.correct_answer }}</td>
                                <td><span v-if="item.is_answered == 1" :class="item.is_correct == 1 ? 'text-success' : 'text-danger'">
                                      <i :class="item.is_correct == 1 ? 'fas fa-check' : 'fas fa-times'"></i>
                                      {{ item.is_correct == 1 ? 'Benar' : 'Salah' }}
                                    </span>
                                    <span v-else class="text-warning">
                                    <i class="fas fa-minus"></i> Tidak dijawab
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </template>
                    </div>
                  </div>

                  <router-link :to="{ path: '/' }" class="btn btn-primary mt-3">
                    <i class="fas fa-home"></i> Kembali ke Beranda
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authFetch, auth } from "@/libs/hxcore";
import Chart from 'chart.js';
import Swal from "sweetalert2";

export default {
  name: "RekapHasilSimbolAritmatika",
  data() {
    return {
      info: { display_name: 'No Name', img_url: '' },
      hasil: null,
      paket: null,
      ref: [],
      detail: [],
      analysis: {
        blocks: [],
        kecepatan: { durasi_detik: 0, durasi_menit: 0, terjawab: 0, detik_per_soal: 0, soal_per_menit: 0 },
        distribusi: { benar: 0, salah: 0, tidak_dijawab: 0, total: 0 },
        answer_distribution: [0,0,0,0,0,0,0,0,0,0],
        tren_konsentrasi: [],
      },
      psikometrik: {},
      profilPsikotes: { rata_rata: 0, label: '' },
      perColumn: [],
      rataRataBenar: 0,
      charts: {},
    };
  },
  created() {
    var info = auth.user();
    if (info) this.info = info;
  },
  mounted() {
    var hasil_id = this.$route.query.hasil_id || sessionStorage.getItem('hasil_simbol_id');
    var ujian_code = this.$route.query.ujian_code;
    
    if (hasil_id) {
      this.loadHasil(hasil_id);
    } else if (ujian_code) {
      this.cariHasil(ujian_code);
    }
  },
  methods: {
    loadHasil(hasil_id) {
      authFetch("/siswa/test/simbol_aritmatika_hasil/" + hasil_id).then((res) => {
        res.json().then((json) => {
          if (json.success) {
            this.hasil = json.data.hasil;
            this.paket = json.data.paket;
            this.ref = json.data.ref;
            this.detail = json.data.detail;
            this.analysis = json.data.analysis || this.analysis;
            this.perColumn = json.data.analysis.per_column || [];
            this.rataRataBenar = json.data.analysis.rata_rata_benar || 0;
            // Verify per-column data vs detail jawaban
            this.verifyPerColumnData();
            this.psikometrik = json.data.psikometrik || {};
            this.profilPsikotes = json.data.profil_psikotes || { rata_rata: 0, label: '' };
            sessionStorage.removeItem('hasil_simbol_id');
            this.$nextTick(() => {
              this.renderCharts();
            });
          }
        });
      });
    },
    cariHasil(ujian_code) {
      authFetch("/siswa/test/simbol_aritmatika_cari/" + ujian_code).then((res) => {
        res.json().then((json) => {
          if (json.success && json.data && json.data.hasil_id) {
            this.loadHasil(json.data.hasil_id);
          } else {
            Swal.fire("Informasi", json.message || "Ujian/Tryout tidak ditemukan", "info");
          }
        });
      }).catch(() => {
        Swal.fire("Informasi", "Ujian/Tryout tidak ditemukan", "info");
      });
    },
    renderCharts() {
      this.renderPerformaChart();
      this.renderDistribusiChart();
      this.renderRadarChart();
    },
    // ===== Grafik Performa (model Tes Koran) =====
    renderPerformaChart() {
      if (!this.$refs.chartPerforma || !this.perColumn.length) return;
      if (this.charts.performa) this.charts.performa.destroy();

      var ctx = this.$refs.chartPerforma.getContext('2d');
      var labels = this.perColumn.map(c => 'Kolom ' + c.kolom);
      var maxVal = Math.max(1, ...this.perColumn.map(c => c.total));

      this.charts.performa = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Jumlah Benar',
              data: this.perColumn.map(c => c.benar),
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.08)',
              fill: true,
              tension: 0.3,
              pointRadius: 5,
              pointHoverRadius: 8,
              pointBackgroundColor: '#2196F3',
              pointBorderColor: '#fff',
              pointBorderWidth: 2,
              borderWidth: 2,
            },
            {
              label: 'Jumlah Salah',
              data: this.perColumn.map(c => c.salah),
              borderColor: '#f44336',
              backgroundColor: 'rgba(244, 67, 54, 0.06)',
              fill: true,
              tension: 0.3,
              pointRadius: 5,
              pointHoverRadius: 8,
              pointBackgroundColor: '#f44336',
              pointBorderColor: '#fff',
              pointBorderWidth: 2,
              borderWidth: 2,
              borderDash: [4, 3],
            },
            {
              label: 'Total Soal',
              data: this.perColumn.map(c => c.total),
              borderColor: 'rgba(0,0,0,0.1)',
              backgroundColor: 'transparent',
              borderWidth: 1,
              borderDash: [2, 4],
              pointRadius: 0,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { padding: 12, boxWidth: 16, usePointStyle: true } },
          scales: {
            yAxes: [{
              ticks: { beginAtZero: true, max: Math.max(maxVal + 3, 10), stepSize: 1 },
              scaleLabel: { display: true, labelString: 'Jumlah Soal' },
            }],
            xAxes: [{ gridLines: { display: false } }],
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (item, data) => {
                var col = this.perColumn[item.index];
                if (!col) return '';
                if (item.datasetIndex === 0) return 'Benar: ' + col.benar + '/' + col.total + ' (' + col.akurasi + '%)';
                if (item.datasetIndex === 1) return 'Salah: ' + col.salah;
                if (item.datasetIndex === 2) return 'Total: ' + col.total + ' soal';
                return '';
              },
              afterLabel: (item) => {
                var col = this.perColumn[item.index];
                if (!col) return '';
                return 'Terjawab: ' + col.terjawab + ' | Tdk jawab: ' + col.tidak_terjawab;
              },
            },
          },
        },
      });
    },
    renderDistribusiChart() {
      if (!this.$refs.chartDistribusi) return;
      var ctx = this.$refs.chartDistribusi.getContext('2d');
      if (this.charts.distribusi) this.charts.distribusi.destroy();
      this.charts.distribusi = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Benar', 'Salah', 'Tidak Dijawab'],
          datasets: [{
            data: [
              this.analysis.distribusi.benar,
              this.analysis.distribusi.salah,
              this.analysis.distribusi.tidak_dijawab,
            ],
            backgroundColor: ['#28a745', '#dc3545', '#6c757d'],
            borderWidth: 2,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { padding: 12 } },
          cutoutPercentage: 60,
          tooltips: {
            callbacks: {
              label: (item, data) => {
                var label = data.labels[item.index] || '';
                var val = data.datasets[0].data[item.index];
                var total = this.analysis.distribusi.total || 1;
                return label + ': ' + val + ' (' + Math.round(val / total * 100) + '%)';
              },
            },
          },
        },
      });
    },
    verifyPerColumnData() {
      // Verify per-column data from server vs detail jawaban (client-side)
      var cols = {};
      this.detail.forEach(function(item) {
        var ci = item.col_index || 1;
        if (!cols[ci]) cols[ci] = { total: 0, benar: 0, salah: 0, tidak: 0, terjawab: 0 };
        cols[ci].total++;
        if (item.is_answered == 1) {
          cols[ci].terjawab++;
          if (item.is_correct == 1) { cols[ci].benar++; }
          else { cols[ci].salah++; }
        } else {
          cols[ci].tidak++;
        }
      });
      // Compare: if mismatch, use client-side data instead
      var match = true;
      if (this.perColumn.length !== Object.keys(cols).length) {
        match = false;
      } else {
        for (var i = 0; i < this.perColumn.length; i++) {
          var srv = this.perColumn[i];
          var cli = cols[srv.kolom];
          if (!cli || srv.benar !== cli.benar || srv.total !== cli.total) {
            match = false;
            break;
          }
        }
      }
      if (!match) {
        // Fallback: rebuild perColumn from detail data
        console.warn('Per-column data mismatch, using client-side calculation');
        this.perColumn = Object.keys(cols).sort(function(a,b) { return a-b; }).map(function(k) {
          var d = cols[k];
          return {
            kolom: parseInt(k),
            label: 'Kolom ' + k,
            total: d.total,
            benar: d.benar,
            salah: d.salah,
            tidak_terjawab: d.tidak,
            terjawab: d.terjawab,
            akurasi: d.total > 0 ? Math.round(d.benar / d.total * 1000) / 10 : 0,
            tingkat_penyelesaian: d.total > 0 ? Math.round(d.terjawab / d.total * 1000) / 10 : 0,
          };
        });
      }
    },
    renderRadarChart() {
      if (!this.$refs.chartRadar) return;
      var ctx = this.$refs.chartRadar.getContext('2d');
      if (this.charts.radar) this.charts.radar.destroy();
      var labels = ['Ketelitian', 'Kecepatan Kerja', 'Konsistensi', 'Konsentrasi', 'Daya Tahan Kerja'];
      var values = [
        (this.psikometrik.ketelitian || {}).skor || 0,
        (this.psikometrik.kecepatan_kerja || {}).skor || 0,
        (this.psikometrik.konsistensi || {}).skor || 0,
        (this.psikometrik.konsentrasi || {}).skor || 0,
        (this.psikometrik.daya_tahan_kerja || {}).skor || 0,
      ];
      this.charts.radar = new Chart(ctx, {
        type: 'radar',
        data: {
          labels: labels,
          datasets: [{
            label: 'Skor Psikometrik',
            data: values,
            backgroundColor: 'rgba(97, 144, 232, 0.2)',
            borderColor: '#6190E8',
            pointBackgroundColor: '#6190E8',
            pointBorderColor: '#fff',
            pointHoverRadius: 5,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scale: {
            ticks: { beginAtZero: true, max: 100, stepSize: 20 },
            pointLabels: { fontSize: 11 },
          },
        },
      });
    },
    rowClass(item) {
      if (item.is_answered != 1) return 'table-warning';
      return item.is_correct == 1 ? '' : 'table-danger';
    },
    labelPsiko(key) {
      var labels = {
        ketelitian: 'Ketelitian',
        kecepatan_kerja: 'Kecepatan Kerja',
        konsistensi: 'Konsistensi',
        konsentrasi: 'Konsentrasi',
        daya_tahan_kerja: 'Daya Tahan Kerja',
      };
      return labels[key] || key;
    },
    warnaSkor(skor) {
      if (skor >= 85) return '#28a745';
      if (skor >= 70) return '#5cb85c';
      if (skor >= 55) return '#FFA000';
      if (skor >= 40) return '#e67e22';
      return '#dc3545';
    },
    akurasiBadge(akurasi) {
      if (akurasi >= 80) return 'badge-success';
      if (akurasi >= 60) return 'badge-warning';
      return 'badge-danger';
    },
    badgeClass(label) {
      if (label === 'Sangat Baik') return 'badge-success';
      if (label === 'Baik') return 'badge-info';
      if (label === 'Cukup') return 'badge-warning';
      if (label === 'Kurang') return 'badge-danger';
      return 'badge-dark';
    },
    cetak() {
      window.print();
    },
  },
  computed: {
    detailPerKolom() {
      var cols = {};
      this.detail.forEach(function(item) {
        var ci = item.col_index || 1;
        if (!cols[ci]) {
          cols[ci] = { kolom: ci, items: [], terjawab: 0 };
        }
        cols[ci].items.push(item);
        if (item.is_answered == 1) cols[ci].terjawab++;
      });
      return Object.values(cols).sort(function(a, b) { return a.kolom - b.kolom; });
    },
    profilWarna() {
      var rata = this.profilPsikotes.rata_rata || 0;
      if (rata >= 85) return '#28a745';
      if (rata >= 70) return '#5cb85c';
      if (rata >= 55) return '#FFA000';
      if (rata >= 40) return '#e67e22';
      return '#dc3545';
    },
  },
  beforeDestroy() {
    Object.values(this.charts).forEach(c => { if (c) c.destroy(); });
  },
};
</script>

<style scoped>
.card-penilaian {
  box-shadow: 0px 13px 13px 0px #00000012;
}
.table-bordered > thead > tr > th {
  border-color: #6190E8 !important;
}
th {
  background-color: #6190E8 !important;
  color: white !important;
}
.table-warning td {
  background-color: #fff3cd !important;
}
.table-danger td {
  background-color: #f8d7da !important;
}
canvas {
  width: 100% !important;
  max-height: 220px;
}

@media print {
  .btn, .btn-group, .card-tools, .toolbar, .sidebar, .main-header, .main-footer {
    display: none !important;
  }
  .content-wrapper {
    margin-left: 0 !important;
    padding: 0 !important;
  }
  .card {
    border: 1px solid #ddd !important;
    box-shadow: none !important;
    break-inside: avoid;
  }
  canvas {
    max-height: 180px !important;
  }
  body {
    font-size: 12px;
  }
  .table {
    font-size: 11px;
  }
}
</style>
